export function buildImageProxyUrl({ format, sourceUrl, referrer }) {
    if (!sourceUrl.startsWith("http")) {
        return sourceUrl; // For temp urls like blob:...
    }
    return `https://rendering.documents.cimpress.io/v1/fusion/images:process?imageUri=${encodeURIComponent(sourceUrl)}&format=${format}&referrer=${referrer}`;
}
//# sourceMappingURL=proxyUrl.js.map